import SettingsKpiCards from '@/components/Settings/SettingsKpiCards'
import UsersTable from '@/components/Settings/UsersTable'
import { USERS_KPI } from '@/components/Settings/settingsKpiPlaceholders'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'

export default function SettingsUsersSection() {
  return (
    <>
      <SettingsKpiCards sectionTitle="User metrics" intro={getSettingsSectionIntro('users-metrics')} items={USERS_KPI} />
      <UsersTable />
    </>
  )
}
